module.exports = __webpack_public_path__ + "static/ai-video-image-8047f4f0c0894152f6b956e39a7a92ce.png";